import { MoreHoriz } from '@mui/icons-material';
import {
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Popover,
} from '@mui/material';
import React, { useState } from 'react';
import { useChatContext } from 'stream-chat-react';
import UserRole from '../../../../shared/AuthRoles';
import { OwnerRole } from '../../../enums/users';
import { useNavigate } from 'react-router';

const SidebarMenu = () => {
    const { client } = useChatContext();
    const navigate = useNavigate();
    const loggedInUser = UserRole();

    const [menuAnchor, setMenuAnchor] = useState<HTMLButtonElement | null>(
        null,
    );

    const menuOpen = Boolean(menuAnchor);

    const handleMarkRead = async () => {
        await client.markChannelsRead();
        setMenuAnchor(null);
    };

    const handleReplies = () => {
        setMenuAnchor(null);
        navigate('/messages/templates');
    };

    return (
        <>
            <IconButton
                onClick={(e) => setMenuAnchor(e.currentTarget)}
                sx={{ p: 0 }}
            >
                <MoreHoriz color='primary' />
            </IconButton>
            <Popover
                open={menuOpen}
                anchorEl={menuAnchor}
                onClose={() => setMenuAnchor(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List>
                    <ListItemButton onClick={handleMarkRead}>
                        <ListItemText primary='Mark all as read' />
                    </ListItemButton>
                    {loggedInUser?.role === OwnerRole.Admin && (
                        <ListItemButton onClick={handleReplies}>
                            <ListItemText primary='Scheduled Messages' />
                        </ListItemButton>
                    )}
                </List>
            </Popover>
        </>
    );
};

export default SidebarMenu;
